<mat-label class="label">{{ label }}</mat-label>
<mat-form-field class="chip-select" appearance="outline" subscriptSizing="dynamic">
  <mat-select [formControl]="control" multiple [placeholder]="placeholder">
    <mat-select-trigger>
      <mat-chip-listbox aria-label="Enter items">
        @for (item of control.value; track item) {
          @if ($index < MAX_DISPLAY_CHIPS) {
            <mat-chip [removable]="true" (removed)="remove(item)" [value]="item" class="chip" [class]="item">
              <!-- TODO: find an another way to not call findItem function to have item information -->
              {{ findItem(item)?.label }}
              <button matChipRemove>
                <mat-icon>close</mat-icon>
              </button>
            </mat-chip>
          }
        }
        @if ((control?.value?.length || 0) > MAX_DISPLAY_CHIPS) {
          <mat-chip class="chip">+ {{ (control?.value?.length || 0) - MAX_DISPLAY_CHIPS }}</mat-chip>
        }
      </mat-chip-listbox>
    </mat-select-trigger>

    @for (item of items; track item) {
      <mat-option [value]="item.value">
        <mat-chip class="chip" [class]="item.value">{{ item.label }}</mat-chip>
      </mat-option>
    }
  </mat-select>
</mat-form-field>
